import { collection, doc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../config';
import { batchStatus } from '../../../../constants/enum';

interface CreateMasterParams {
  companyId: string;
  fileName: string;
  filePath: string;
  fileSize: string;
  contentType: string;
  rowCount: number;
  csvColumns: string[];
  // マスタ登録時に確定した照合キー列。Cloud SQL の master_datasets.search_key と同値（#3082）。
  searchKey: string;
  uploadedByUid: string;
  uploadedByName: string;
  uploadedByIcon: string | null;
  // 代理ログイン中のアップロードか（#3343）。true のとき uploadedByName には「事務局」を渡す。
  isProxy?: boolean;
  // 代理操作した運営スタッフの UID（#3343）。代理でなければ undefined。
  operatorId?: string | null;
}

export const createMaster = async (params: CreateMasterParams): Promise<string> => {
  const mastersRef = collection(db, 'masters');
  const newDocRef = doc(mastersRef);

  const now = Timestamp.now();

  await setDoc(newDocRef, {
    company_id: params.companyId,
    file_name: params.fileName,
    file_path: params.filePath,
    file_size: params.fileSize,
    content_type: params.contentType,
    row_count: params.rowCount,
    csv_columns: params.csvColumns,
    search_key: params.searchKey,
    batch_status: batchStatus.processing,
    uploaded_by_uid: params.uploadedByUid,
    uploaded_by_name: params.uploadedByName,
    uploaded_by_icon: params.uploadedByIcon,
    // 代理操作の記録（#3343）。Firestore は undefined を保存できないため代理時のみ書く。
    ...(params.isProxy === true && {
      is_proxy: true,
      ...(params.operatorId && { operator_id: params.operatorId }),
    }),
    created_at: now,
    updated_at: now,
  });

  return newDocRef.id;
};
